import { createRfpGuideHttpClient } from '../infra/createRfpGuideHttpClient'
import { ProposalRepository } from '../infra/ProposalRepository'

export type ToggleAwardAutoSubmitFactoryDependencies = {
  repository: ProposalRepository
}

export function toggleAwardAutoSubmitFactory({
  repository,
}: ToggleAwardAutoSubmitFactoryDependencies) {
  return async function toggleAwardAutoSubmitImpl(rfpId: string, autoSubmit: boolean) {
    return repository.toggleAwardAutoSubmit(rfpId, autoSubmit)
  }
}

export function toggleAwardAutoSubmit(rfpId: string, autoSubmit: boolean) {
  const httpClient = createRfpGuideHttpClient()
  const repository = new ProposalRepository({ httpClient })
  const submit = toggleAwardAutoSubmitFactory({ repository })

  return submit(rfpId, autoSubmit)
}
